export default __webpack_public_path__ + "static/media/cv.0f28de6d.pdf";